<template>
  <div class="media" :class="playerClass">
    <div class="media__player" v-if="isPlaceholderPresent && isVideoPresent" @click="play">
      <span class="icon-player media__icon"></span>
      <video
        width="420"
        height="420"
        controls="true"
        ref="videoRef"
        :poster="placeholder ? baseUrlMedia + placeholder.fileId + '/' + placeholder.fileName + '?width=840' : ''"
        @ended="onEnd"
      >
        <source :src="video ? baseUrlMedia + video.fileId + '/' + video.fileName : ''" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="media__player" v-else-if="isVideoPresent" @click="play">
      <span class="icon-player media__icon"></span>
      <video width="420" height="420" controls="true" ref="videoRef" @ended="onEnd">
        <source :src="video ? baseUrlMedia + video.fileId + '/' + video.fileName : ''" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="media__player media__player_poster" v-else-if="isPlaceholderPresent">
      <img
        :src="placeholder ? baseUrlMedia + placeholder.fileId + '/' + placeholder.fileName + '?width=840' : ''"
        :alt="alt"
        class="media__image"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  interface PlaceholderItem {
    fileId?: string;
    fileName?: string;
    external?: {
      title?: string;
      [key: string]: any;
    };
    title?: string;
    [key: string]: any;
  }

  interface VideoItem {
    fileId?: string;
    fileName?: string;
    [key: string]: any;
  }

  const props = defineProps<{
    placeholder?: PlaceholderItem;
    video?: VideoItem;
  }>();

  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);

  const playerClass = ref('');
  const videoRef = ref<HTMLVideoElement | null>(null);

  function setProperFieldExternalFirst(obj: PlaceholderItem | undefined, field: string): string {
    return obj && obj.external && obj.external[field] ? obj.external[field] : obj && obj[field] ? obj[field] : '';
  }

  const alt = computed(() => setProperFieldExternalFirst(props.placeholder, 'title'));
  const isPlaceholderPresent = computed(() => props.placeholder && props.placeholder.fileId && props.placeholder.fileName);
  const isVideoPresent = computed(() => props.video && props.video.fileId && props.video.fileName);

  function play() {
    playerClass.value = 'playing';
    if (videoRef.value) {
      videoRef.value.play();
    }
  }

  function onEnd() {
    playerClass.value = '';
  }
</script>
